/* Client wrapper for the studio's branded HTML email endpoint (worker /api/notify).
   Fire-and-forget: returns "delivered" | "simulated" | "failed". Without a
   RESEND_API_KEY on the worker the endpoint returns "simulated" so the UI stays
   honest and nothing throws. */

export type NotifyResult = "delivered" | "simulated" | "failed";

export interface NotifyInput {
  to: string;
  subject: string;
  heading: string;
  body: string;
  cta?: { label: string; url: string };
}

export async function notify(input: NotifyInput): Promise<NotifyResult> {
  try {
    const r = await fetch("/api/notify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(input),
    });
    const d = (await r.json().catch(() => ({}))) as { result?: NotifyResult; error?: string };
    lastError = d.error ?? (r.ok ? undefined : `HTTP ${r.status}`);
    return d.result ?? "failed";
  } catch (e: any) {
    lastError = String(e?.message || e).slice(0, 160);
    return "failed";
  }
}

/** Why the last send failed, when it did. Read straight after awaiting notify(). */
let lastError: string | undefined;
export const lastNotifyError = () => lastError;
